import React, { ReactElement, useState, useEffect } from 'react';
import './styles.scss';
import { ConfirmationDialog } from '../Dialogs/Confirmation/Confirmation';
import { ContinueDialog } from '../Dialogs/Continue/Continue';
import { LoadingDialog } from '../Dialogs/Loading/Loading';
import { deleteAdmin } from './updateAdmin';

import { User } from './utils';
type Props = {
  user: User;
  hasBeenEdited: boolean;
  onChange: () => void;
};

export const RemoveAdmin = ({
  user,
  hasBeenEdited,
  onChange,
}: Props): ReactElement | null => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showContinueDialog, setShowContinueDialog] = useState(false);
  const [isLoading, setLoading] = useState<boolean>(false);

  function handleChange() {
    // Here, we invoke the callback with the new value
    onChange();
  }

  useEffect(() => {
    if (hasBeenEdited) {
      setShowConfirmationDialog(true);
    }
  }, [hasBeenEdited, onChange]);

  return (
    <div>
      {showConfirmationDialog && !isLoading && (
        <ConfirmationDialog
          headline={`Are you sure you want to delete ${user.name}?`}
          byline={`After deleting the admin user, the account will be destroyed and cannot be restored.`}
          dismissButtonText="Cancel"
          confirmButtonText="Delete admin"
          confirmButtonColor="red"
          warning={true}
          confirmButtonCallback={async (): Promise<void> => {
            setLoading(true);
            const { data } = await deleteAdmin(user.email);
            setShowConfirmationDialog(false);
            if (data !== null) {
              setLoading(false);
              setShowContinueDialog(true);
            } else {
              setLoading(false);
              alert(
                `Unable to delete admin user, please contact an administrator quoting adminId:${user.id} to help resolve this.`
              );
            }
            // handleChange();
          }}
          dismissButtonCallback={(): void => {
            setShowConfirmationDialog(false);
            handleChange();
          }}
        />
      )}
      {isLoading && <LoadingDialog heading={'Saving your work'} />}
      {showContinueDialog && (
        <ContinueDialog
          headline={`${user.name}'s account has been deleted`}
          continueButtonText="Continue"
          continueButtonCallback={(): void => {
            setShowContinueDialog(false);
            handleChange();
          }}
        />
      )}
    </div>
  );
};
